import Vue from "vue";

import itrus, { components, utils } from "itrus";

const { browser } = utils;
const LIBROOT = window.APP_CONFIG.configRootPath; // lib公用插件路径

components.forEach((component) => {
  Vue.use(component);
});

Vue.prototype.$itrus = itrus;

Object.keys(utils).forEach((name) => {
  Vue.prototype["$" + name] = utils[name];
});

// 判断是否IE11浏览器
Vue.prototype.$ie11 = browser.ie11;
// 客户端是否移动端
Vue.prototype.$mobile = browser.mobile;
Vue.prototype.$client = browser.mobile ? "mobile" : "pc";
Vue.prototype.$lib_icon_path = LIBROOT + "/icon/";

export { LIBROOT };



// WEBPACK FOOTER //
// ./src/utils/itrus.js